import type { Dispatch, AnyAction } from 'redux';

import * as FindTimezoneAPI from 'ab-api/web/timezone/find';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function find(latitude: number, longitude: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindTimezoneAPI.W_Timezone_FindByLatitudeAndLongitude_VM>(FindTimezoneAPI.URL(latitude, longitude));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
